import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4z"
}), 'ModeCommentRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ModeCommentRounded.js
// module id = 4873
// module chunks = 2